module.exports = __webpack_public_path__ + "static/img/trans_single_download.b53167b0.gif";